"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeCSV = void 0;
var rxIsInt = /^\d+$/;
var rxIsFloat = /^\d*\.\d+$|^\d+\.\d*$/;
var IkeCSV = /** @class */ (function () {
    function IkeCSV(text) {
        this.delimiter = ',';
        this.lineTerminator = '\n';
        this.quoteChar = '"';
        this.rows = [];
        this.headers = [];
        if (text == null) {
            return;
        }
        this.parse(text);
    }
    Object.defineProperty(IkeCSV.prototype, "isValid", {
        get: function () {
            if (this.headers.length === 0) {
                return false;
            }
            for (var _i = 0, _a = this.headers; _i < _a.length; _i++) {
                var header = _a[_i];
                if (header.length > IkeCSV.MAX_HEADER_LENGTH) {
                    return false;
                }
            }
            return true;
        },
        enumerable: false,
        configurable: true
    });
    IkeCSV.prototype.getHeaderIndex = function (header) {
        return this.headers.indexOf(header);
    };
    // Simple CSV Parser stolen from https://github.com/okfn/csv.js/blob/master/csv.js
    IkeCSV.prototype.parse = function (input) {
        var s = input.trim().replace(/\r\n/g, '\n');
        var inQuote = false;
        var fieldQuoted = false;
        var field = ''; // Buffer for building up the current field
        var row = [];
        var out = [];
        function processField(currentField) {
            var output = currentField;
            if (fieldQuoted === false) {
                // If field is empty set to null
                if (currentField === '') {
                    currentField = null;
                    // If the field was not quoted and we are trimming fields, trim it
                }
                else {
                    output = currentField = currentField.trim();
                }
                // Convert unquoted numbers to their appropriate types
                if (rxIsInt.test(currentField)) {
                    output = parseInt(currentField, 10);
                }
                else if (rxIsFloat.test(currentField)) {
                    output = parseFloat(currentField);
                }
            }
            return output;
        }
        for (var i = 0; i < s.length; i += 1) {
            var cur = s.charAt(i);
            // If we are at a EOF or EOR
            if (inQuote === false &&
                (cur === this.delimiter || cur === this.lineTerminator)) {
                field = processField(field);
                // Add the current field to the current row
                row.push(field);
                // If this is EOR append row to output and flush row
                if (cur === this.lineTerminator) {
                    out.push(row);
                    row = [];
                }
                // Flush the field buffer
                field = '';
                fieldQuoted = false;
            }
            else {
                // If it's not a quotechar; add it to the field buffer
                if (cur !== this.quoteChar) {
                    field += cur;
                }
                else {
                    if (!inQuote) {
                        // We are not in a quote, start a quote
                        inQuote = true;
                        fieldQuoted = true;
                    }
                    else {
                        // Next char is quotechar, this is an escaped quotechar
                        if (s.charAt(i + 1) === this.quoteChar) {
                            field += this.quoteChar;
                            // Skip the next char
                            i += 1;
                        }
                        else {
                            // It's not escaping, so end quote
                            inQuote = false;
                        }
                    }
                }
            }
        }
        field = processField(field);
        row.push(field);
        out.push(row);
        this.headers = out.slice(0, 1)[0] || [];
        this.headers = this.headers.map(function (c) { return String(c); });
        this.rows = out.slice(1) || [];
    };
    IkeCSV.MAX_HEADER_LENGTH = 256;
    return IkeCSV;
}());
exports.IkeCSV = IkeCSV;
//# sourceMappingURL=csv.js.map